<mat-icon class="user-blocked-icon material-icons-outlined" svgIcon="account_cancel_outline" />
